import { useState } from "react";
import { Grid3X3, List, Filter, Check, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import ProductCard from "./ProductCard";

export const ProductGrid = ({
  products,
  collections = [],
  theme,
  viewMode,
  setViewMode,
  selectedCollection,
  setSelectedCollection,
  onAddToCart,
  subdomain,
  totalCount,
}) => {
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // Normalize collections to ensure we have a name and ID
  const safeCollections = Array.isArray(collections) ? collections : [];

  // Manual filtering for extra robustness
  const filteredCollections = safeCollections.filter(c => {
    if (!c || !c.name) return false;
    if (!searchQuery) return true;
    return c.name.toLowerCase().includes(searchQuery.toLowerCase());
  });

  const selectedCollectionName = selectedCollection === "all"
    ? "All Collections"
    : safeCollections.find(c => (c.collection_id || c._id) === selectedCollection)?.name || "Select Collection...";

  return (
    <section className="py-16 bg-slate-50" id="products">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
          <div>
            <h2
              className="text-3xl font-bold mb-2"
              style={{ color: theme.primary_color }}
            >
              Our Products
            </h2>

          </div>

          {/* Filters and View Options */}
          <div className="flex items-center gap-3 flex-wrap">


            <div className="flex items-center border rounded-lg bg-white">
              <Button
                variant={viewMode === "grid" ? "secondary" : "ghost"}
                size="icon"
                onClick={() => setViewMode("grid")}
              >
                <Grid3X3 className="w-4 h-4" />
              </Button>
              <Button
                variant={viewMode === "list" ? "secondary" : "ghost"}
                size="icon"
                onClick={() => setViewMode("list")}
              >
                <List className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </div>

        {/* Products Grid/List */}
        {products.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-slate-500 text-lg">No products found</p>
          </div>
        ) : (
          <div className={
            viewMode === "grid"
              ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
              : "flex flex-col gap-4"
          }>
            {products.map((product) => (
              <ProductCard
                key={product.product_id}
                product={product}
                theme={theme}
                viewMode={viewMode}
                onAddToCart={onAddToCart}
                subdomain={subdomain}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductGrid;
